// extracted by mini-css-extract-plugin
module.exports = {"resumeTitle":"resume_resumeTitle__3Wixd","ligneTotalTitle":"resume_ligneTotalTitle__3XYwM","ligneTotal":"resume_ligneTotal__3gObJ"};